import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BenefitsComponent } from "./benefits.component";

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Benefits'
    },
    children: [
      {
        path: '',
        component: BenefitsComponent,
        data: {
          title: 'Home'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BenefitsRoutingModule { }
